import { RenderForRoles } from '@/auth/RenderForRoles';
import { useErrorReporting } from '@/ErrorReporting';
import { useEventResolutionEnabled } from '@/features/events/hooks/useEventResolutionEnabled';
import { TaskButton } from '@/features/tasks/TaskPanel';
import Button from '@imminently/decisively-ui/Button';
import { useHotkey } from '@/common/editor/RuleAuthor/util';
import { FeatureGuard } from '@/components/FeatureGuard';
import { ReleaseNotifications } from '@/features/release';
import { Route, Link } from 'react-router-dom';
import Icon from '@imminently/decisively-ui/Icon';
import { CommandSearch } from './CommandSearch';
import { Navigation } from './Navigation';
import { UserMenu } from './UserMenu';
import { LocalhostGuard } from '@/auth/ComponentGuard';

export const Header = ({ routes, onToggleSidebar }: { routes: Route[]; onToggleSidebar: () => void }) => {
  const errorReporting = useErrorReporting();
  const eventResolutionEnabled = useEventResolutionEnabled();

  useHotkey('mod+shift+f', () => {
    errorReporting?.open();
  });

  const hasSidebarItems = routes.length > 0;

  return (
    <header data-header className="flex items-center gap-4 pr-4 pl-0 w-full min-h-14 text-sidebar-foreground bg-sidebar">
      <Button
        icon
        label="Toggle sidebar"
        variant="ghost"
        intent="sidebar"
        placement="right"
        onClick={onToggleSidebar}
        disabled={!hasSidebarItems}
      >
        <Icon name="open-sidebar" />
      </Button>
      <Navigation />
      <div className="grow" />
      <div className="flex items-center gap-1">
        <FeatureGuard feature="developer.command_palette">
          <CommandSearch />
        </FeatureGuard>
        <LocalhostGuard>
          <Button
            icon
            label="Dev"
            variant="ghost"
            intent="sidebar"
            asChild
          >
            <Link to="/dev/design" className="cursor-pointer">
              <Icon name="code" />
            </Link>
          </Button>
        </LocalhostGuard>
        <FeatureGuard feature={eventResolutionEnabled ? "experimental.event_resolution" : "experimental.tasks"}>
          <RenderForRoles roles={["task-read", "task-read-all"]}>
            <TaskButton />
          </RenderForRoles>
        </FeatureGuard>
        <ReleaseNotifications />
      </div>
      <UserMenu />
    </header>
  );
};
